(() => {
  const CUSTOM_FEE_CENTS = 4000; // 40 QAR in cents

  const formatArabicMoney = (value) => {
    return new Intl.NumberFormat('ar-QA-u-nu-arab', {
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value).replace(/٫/g, ',');
  };

  const formatMoney = (cents, locale = 'ar') => {
    const amount = cents / 100;
    if (locale === 'ar' || document.documentElement.lang === 'ar') {
      return `${formatArabicMoney(amount)} ر.ق`;
    }
    return `${amount.toFixed(2)} QAR`;
  };

  const syncVariantAndPrice = (container) => {
    const isCustomOnly = container.dataset.mshqCustomOnly === 'true';
    const productSection = container.closest('.product') || container.closest('.product-info') || container.closest('section') || document;
    const isCustom = isCustomOnly || container.querySelector('input[name="mshq_order_method"]:checked')?.value === 'custom';
    const locale = container.dataset.mshqLocale || (document.documentElement.lang === 'ar' ? 'ar' : 'en');
    const targetMethodValue = isCustom ? 'عبارة مخصصة' : 'جاهز كما هو';

    if (isCustomOnly) {
      // Inherently custom product: keep original base price and single variant
      return;
    }

    const variantsScript = productSection.querySelector('[data-mshq-product-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch {}

    const form = container.closest('form') || productSection.querySelector('form[action*="/cart/add"]');
    const variantIdInput = form?.querySelector('input[name="id"]');
    const currentVariantId = variantIdInput ? Number(variantIdInput.value) : 0;
    const currentVariant = variants.find(v => v.id === currentVariantId) || variants[0];

    let finalCents = null;

    if (variants.length > 0) {
      const hasMethodVariant = variants.some(v => 
        (v.options && (v.options.includes('جاهز كما هو') || v.options.includes('عبارة مخصصة'))) ||
        v.title.includes('جاهز كما هو') || v.title.includes('عبارة مخصصة')
      );

      if (hasMethodVariant) {
        const matchingVariant = variants.find(v => {
          if (!v.options || v.options.length <= 1) {
            return (v.options && v.options[0] === targetMethodValue) || v.title.includes(targetMethodValue);
          }
          const sameOtherOptions = v.options.every((opt, idx) => {
            if (opt === 'جاهز كما هو' || opt === 'عبارة مخصصة') return true;
            return currentVariant && currentVariant.options[idx] === opt;
          });
          const isTargetMethod = v.options.includes(targetMethodValue) || v.title.includes(targetMethodValue);
          return sameOtherOptions && isTargetMethod;
        });

        if (matchingVariant) {
          if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
          }
          finalCents = Number(matchingVariant.price);
        }
      }
    }

    const priceElements = productSection.querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last');
    priceElements.forEach((priceEl) => {
      if (finalCents !== null) {
        priceEl.textContent = formatMoney(finalCents, locale);
      } else {
        const baseCents = Number(priceEl.dataset.mshqBasePrice);
        if (Number.isFinite(baseCents) && baseCents > 0) {
          const fallbackCents = isCustom ? baseCents + CUSTOM_FEE_CENTS : baseCents;
          priceEl.textContent = formatMoney(fallbackCents, locale);
        }
      }
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-mshq-order-method-form]').forEach((container) => {
      const isCustomOnly = container.dataset.mshqCustomOnly === 'true';
      const customField = container.querySelector('[data-mshq-custom-text-field]');
      const customText = container.querySelector('[data-mshq-custom-text]');
      const orderProperty = container.querySelector('[data-mshq-order-property]');

      const isCustom = () => isCustomOnly || container.querySelector('input[name="mshq_order_method"]:checked')?.value === 'custom';

      const updateFields = () => {
        const custom = isCustom();
        if (customField) customField.hidden = !custom;
        if (customText) {
          customText.disabled = !custom;
          customText.required = custom;
        }
        const note = container.querySelector('[data-mshq-custom-note]');
        if (note) note.hidden = !custom;
        if (orderProperty) {
          if (isCustomOnly) {
            orderProperty.value = container.dataset.mshqLocale === 'ar' ? 'طلب مخصص' : 'Custom order';
          } else {
            orderProperty.value = custom
              ? (container.dataset.mshqLocale === 'ar' ? 'عبارة مخصصة (+٤٠ ر.ق)' : 'Custom text (+QAR 40)')
              : (container.dataset.mshqLocale === 'ar' ? 'جاهز كما هو' : 'Ready as shown');
          }
        }
        syncVariantAndPrice(container);
      };

      if (!container.dataset.mshqOrderBound) {
        container.dataset.mshqOrderBound = 'true';
        container.addEventListener('change', updateFields);
        customText?.addEventListener('input', updateFields);
      }

      const productSection = container.closest('.product') || container.closest('section');
      if (productSection && !productSection.dataset.mshqPriceObserved) {
        productSection.dataset.mshqPriceObserved = 'true';
        const priceContainer = productSection.querySelector('.price') || productSection;
        let isUpdating = false;
        const observer = new MutationObserver(() => {
          if (isUpdating) return;
          isUpdating = true;
          syncVariantAndPrice(container);
          setTimeout(() => {
            isUpdating = false;
          }, 50);
        });
        observer.observe(priceContainer, { childList: true, subtree: true });
      }

      updateFields();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('product-info:loaded', (event) => initialize(event.target));
})();
